<template>
    <section>
        <div class="grid xs-grid-cols-1">
            <div class="h4 text-bold">{{ molang('search.common.schools') }}</div>
            <div>
                <template v-if="msp.contentVariant.isUnfilteredUnpaginatedCity">
                    <div>{{ molang('search.common.seeAll') }} <a class="link" :href="getSchoolsLink">{{ getGeoDisplayText }} schools.</a></div>
                    {{ molang('search.common.ratingsProvided') }} <img :src="getSchoolImagePath" alt="great school" loading="lazy" />
                </template>
                <template v-else>
                    <span class="place">{{ getGeoDisplayText }} Schools</span>.
                    {{ molang('search.common.ratingsProvided') }}
                    <img :src="getSchoolImagePath" alt="great school" loading="lazy" />
                    <a class="link" :href="getSchoolsLink">{{ molang('search.common.seeAll') }}…</a>
                </template>
            </div>
        </div>
    </section>
</template>

<script src="./market-school.js"></script>
